import { FormGroup } from '@angular/forms';
import { formPaths } from '@shared/constants/form-paths.const';
import { addRemoveError, checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { FormValidationError } from '@shared/models/interfaces/form-validation-error.interface';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isEqual } from 'lodash-es';

export const baseSocialeCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath = formPaths.baseSociale,
    suppCondition = true,
    errorStatus?: string
): void => {
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus);
};

export const getBaseSocialeGroup = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.baseSociale);
};

export const getBaseSocialeControl = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.baseSociale}.${path}`);
};

export const normeRedazRegolamHelper = (form: FormGroup, targetPath: string, suppCondition = true, customError?: FormValidationError) => {
    const targetControl = getBaseSocialeControl(form, targetPath);
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted.length - 1];
    const errors = targetControl.errors ? targetControl.errors : {};
    const errorElement: FormValidationError = customError ?? { status: REQUIRED_STATUS };

    addRemoveError(isNilOrEmpty(targetControl?.value) && checkNormeRedazRegolam(form) && suppCondition, errors, errorName, errorElement);

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

export const checkNormeRedazRegolam = (form: FormGroup): boolean => {
    const my_CkNormeSocioLavorat = toNum(getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value);
    const my_CkRedazRegolam = toNum(getBaseSocialeControl(form, 'my_CkRedazRegolam')?.value);
    return my_CkNormeSocioLavorat === 1 && my_CkRedazRegolam === 1;
};
